module.exports = __webpack_public_path__ + "img/vision2.6a05359c.png";